import PropTypes from 'prop-types';

export const giftCardProps = {
  gifteeEmail: PropTypes.string,
  gifteeName: PropTypes.string,
  fromName: PropTypes.string,
  deliveryDate: PropTypes.string,
  message: PropTypes.string,
  originalAmountCents: PropTypes.number,
  giftCardTemplateId: PropTypes.string,
};

export const giftCard = PropTypes.shape(giftCardProps);
